import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'question-type-translation',
  templateUrl: './question-type-translation.component.html'
})
export class QuestionTypeTranslationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
